<template>
	<router-link class="navigation__item" v-bind:class="{ active: isActive }" :to="route" >
		{{label}}
	</router-link>
</template>

<script>
export default {
	props: [ 'label', 'id', 'isActive', 'route' ]
}
</script>